import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <h3 className="text-white font-serif font-bold text-2xl">Baitho</h3>
            <p className="text-sm leading-relaxed">
              Bringing Indian families closer, one conversation at a time.
            </p>
            <div className="flex items-center gap-2 text-sm">
              <span>Made with</span>
              <Heart className="w-4 h-4 text-baitho-rust fill-baitho-rust" />
              <span>in India</span>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-baitho-orange transition-colors">Home</Link>
              </li>
              <li>
                <a href="#how-it-works" className="hover:text-baitho-orange transition-colors">How It Works</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-baitho-orange transition-colors">Shipping & Delivery</a>
              </li>
              <li>
                <a href="#" className="hover:text-baitho-orange transition-colors">Returns & Refunds</a>
              </li>
              <li>
                <a href="#" className="hover:text-baitho-orange transition-colors">FAQs</a>
              </li>
              <li>
                <a href="#" className="hover:text-baitho-orange transition-colors">Privacy Policy</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-1 flex-shrink-0" />
                <a href="mailto:hellobaitho@gmail.com" className="hover:text-baitho-orange transition-colors">
                  hellobaitho@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>Mumbai, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Baitho. All rights reserved.</p>
          <Link 
            to="/admin" 
            className="text-gray-700 hover:text-gray-500 transition-colors text-xs mt-2 inline-block opacity-50"
          >
            •
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
